import { MenuRepository } from '../../domain/interfaces/MenuRepository';
import type { MenuItem } from '../../domain/models/MenuItem';
import { menuApi, type MenuApiResponse } from './menuApiSlice';
import type { AppDispatch } from '@/app/store/store';
import { executeQuery } from '@/shared/features/query/utils/queryUtils';

/**
 * Menu Repository Adapter
 * Infrastructure layer - implements MenuRepository
 * Uses query client (currently RTK Query) for automatic caching and request deduplication
 */
export class MenuRepositoryAdapter implements MenuRepository {
  private readonly dispatch: AppDispatch;

  constructor(dispatch: AppDispatch) {
    this.dispatch = dispatch;
  }

  async fetchMenu(): Promise<MenuItem[]> {
    try {
      const initiateResult = menuApi.endpoints.getMenu.initiate();
      const result = await executeQuery<MenuApiResponse>(initiateResult, this.dispatch);
      return result?.hamburger ?? [];
    } catch (error) {
      console.error('Error fetching menu:', error);
      return [];
    }
  }
}

